import type { TempMedia } from '@/payload-types';

const IMAGE_MIME_PREFIX = 'image/';

export function getExtension(media: TempMedia): string {
    const name = media.filename || '';
    const dot = name.lastIndexOf('.');
    if (dot !== -1 && dot < name.length - 1) {
        return name.slice(dot).toLowerCase();
    }
    const mime = media.mimeType || '';
    if (mime.startsWith('application/pdf')) return '.pdf';
    if (mime.startsWith('text/')) return '.txt';
    return '.file';
}

export function isImage(media: TempMedia): boolean {
    return (media.mimeType || '').startsWith(IMAGE_MIME_PREFIX);
}
